import { UserModel } from '@akin-home/user';
import { EmailPostBody, sendEmail } from './common';

interface ContactUsEmailParams {
  user: UserModel;
  topic: string;
  text: string;
}

const formatContactUsEmailBody = (
  params: ContactUsEmailParams
): EmailPostBody => ({
  subject: `App Feedback Submitted: ${params.topic}`,
  text: `
  App Feedback Submission\n
  Type: ${params.topic}\n
  === User ===\n
  Name: ${params.user.name}\n
  Username: ${params.user.username || 'Unknown'}\n
  Email: ${params.user.email || 'Unknown'}\n
  Phone: ${params.user.phoneNumber || 'Unknown'}\n\n
  === Message ===\n
  ${params.text}`,
});

const sendContactUsEmail = async (params: ContactUsEmailParams) =>
  await sendEmail('/contactus', formatContactUsEmailBody(params));

export default sendContactUsEmail;
